import { useLocation, Navigate } from "react-router";
import { getUserDetails } from "../../Utils/Functions";


const PrivateRoute = ({ children }) => {

    const user = getUserDetails();
    const location = useLocation();

    if (!user) {
        // Redirige vers login en gardant la page d'origine pour le redirect après connexion
        return <Navigate to={`/login?redirect=${location.pathname}`} replace />;
    }


    return children;
}

export default PrivateRoute;